import type { IAthleteContent } from './IAthleteContent';

/** The slugs of the athletes. */
export enum AthleteSlug {
  AlvinDedeaux = 'alvin-dedeaux',
  ShyanneOrvis = 'shyanne-orvis',
  MikeWardian = 'mike-wardian',
  EvyLeibfarth = 'evy-leibfarth',
  ErinTon = 'erin-ton',
  DaneJackson = 'dane-jackson',
  BrigetteTakeuchi = 'brigette-takeuchi'
}

export const athletesData: Record<AthleteSlug, IAthleteContent> = {
  'alvin-dedeaux': {
    name: 'Alvin Dedeaux',
    slug: 'alvin-dedeaux',
    hero: {
      image: '/images/bureau-of-adventure/AlvinDedeaux/hero.png',
      alt: 'Under a cloudy sky, Alvin stands in the shallows of a wide river, casting a long fly-fishing line over a rocky, white gravel bank.'
    },
    profile: {
      image: '/images/bureau-of-adventure/AlvinDedeaux/profile.png',
      alt: 'Alvin Dedeaux'
    },
    socialLinks: {
      instagram: 'https://www.instagram.com/alvin_dedeaux_fly_fishing/',
      youtube: 'https://www.youtube.com/c/AlvinDedeauxFlyFishing'
    },
    bio: {
      title: 'Meet Alvin Dedeaux',
      paragraphs: [
        {
          id: 1,
          text: 'Texas-based fly-fishing guide Alvin Dedeaux has been running rivers for nearly 50 years, building a legacy on his angling skills and conservation advocacy. Alvin is the Owner and operator of All Water Guides, which was awarded 2025 Orvis Outfitter of the Year.'
        },
        {
          id: 2,
          text: `Alvin is known for chasing bass and redfish across Texas and for founding the LoCo Trash Bash—an all-volunteer cleanup that's hauled 50+ tons of trash from the Lower Colorado.`
        }
      ]
    },
    gallery: [
      {
        id: 1,
        image: '/images/bureau-of-adventure/AlvinDedeaux/bio-image-1.png',
        alt: 'Alvin is shown at the helm of a boat on a sunlit river, fully geared up in a life vest, orange neck gaiter, and trucker hat.'
      },
      {
        id: 2,
        image: '/images/bureau-of-adventure/AlvinDedeaux/bio-image-2.png',
        alt: 'Alvin sits at a desk in a studio filled with lighting and camera equipment, gesturing toward the lens in front of a Texas flag.'
      },
      {
        id: 3,
        image: '/images/bureau-of-adventure/AlvinDedeaux/bio-image-3.png',
        alt: 'Alvin smiles while wading in shallow water, holding a large, silver fish he has caught.'
      },
      {
        id: 4,
        image: '/images/bureau-of-adventure/AlvinDedeaux/bio-image-4.png',
        alt: 'Alvin navigates a boat down a river while a companion stands at the bow casting a fishing line against a backdrop of lush green trees.'
      }
    ],
    products: [
      {
        id: 1,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-1-46f5f0.png'
      },
      {
        id: 2,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-2.png'
      },
      {
        id: 3,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-3.png'
      },
      {
        id: 4,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-4.png'
      }
    ]
  },
  'shyanne-orvis': {
    name: 'Shyanne Orvis',
    slug: 'shyanne-orvis',
    hero: {
      image: '/images/bureau-of-adventure/ShyanneOrvis/hero.png',
      alt: 'Shyanne Orvis fly fishing on a boat platform in calm ocean waters under a clear blue sky.'
    },
    profile: {
      image: '/images/bureau-of-adventure/ShyanneOrvis/profile.png',
      alt: 'Shyanne Orvis'
    },
    socialLinks: { instagram: 'https://www.instagram.com/shyonthefly' },
    bio: {
      title: 'Meet Shyanne Orvis',
      paragraphs: [
        {
          id: 1,
          text: 'Originally from Flint, Michigan and now based in Carbondale, Colorado, Shyanne Orvis is a fly-fishing guide, travel host, and children’s book author dedicated to connecting people to wild places. '
        },
        {
          id: 2,
          text: 'Whether she’s guiding Colorado’s Gold Medal rivers, chasing trout in the alpine, or wading salt-water flats, she is all heart, curiosity, and a deep commitment to conservation. She’s especially passionate about welcoming more women into the sport—and now, as a mom, she’s sharing that spirit with her son.'
        }
      ]
    },
    gallery: [
      {
        id: 1,
        image: '/images/bureau-of-adventure/ShyanneOrvis/bio-image-1.png',
        alt: 'Low-angle view of Shyanne Orvis standing on a boat with a fly rod, wearing light blue pants and pink sandals.'
      },
      {
        id: 2,
        image: '/images/bureau-of-adventure/ShyanneOrvis/bio-image-2.png',
        alt: 'Shyanne Orvis sitting on a blue chair at the beach with a fishing rod and gear beside her.'
      },
      {
        id: 3,
        image: '/images/bureau-of-adventure/ShyanneOrvis/bio-image-3.png',
        alt: 'Shyanne Orvis smiling while holding a large fish beside her boat on the open sea.'
      },
      {
        id: 4,
        image: '/images/bureau-of-adventure/ShyanneOrvis/bio-image-4.png',
        alt: 'Shyanne Orvis and a fellow angler releasing a fish into turquoise water beside their boat.'
      }
    ],
    products: [
      {
        id: 1,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-1-46f5f0.png'
      },
      {
        id: 2,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-2.png'
      },
      {
        id: 3,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-3.png'
      },
      {
        id: 4,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-4.png'
      }
    ]
  },
  'mike-wardian': {
    name: 'Mike Wardian',
    slug: 'mike-wardian',
    hero: {
      image: '/images/bureau-of-adventure/MarkWardian/hero.png',
      alt: 'Mike Wardian crossing the race finish line mid-air, wearing a white tank top and black shorts, with banners and spectators in the background.'
    },
    profile: {
      image: '/images/bureau-of-adventure/MarkWardian/profile.png',
      alt: 'Mike Wardian smiling with arms crossed, wearing a black Teva cap and T-shirt, standing outdoors surrounded by greenery.'
    },
    socialLinks: { instagram: 'https://www.instagram.com/mikewardian/' },
    bio: {
      title: 'Meet Mike Wardian',
      paragraphs: [
        {
          id: 1,
          text: `Whether it's running backyard ultramarathons, local marathons & 5ks, setting World Records or completing multi-day treks across multiple countries, Mike Wardian is a relentless force of endurance and positivity.`
        },
        {
          id: 2,
          text: 'He’s won seven marathons on seven continents in seven days—twice-and even run the Appalachian Trail in 60 days wearing Teva Aventrail. A full-time ship broker, pro athlete, father, vizsla dog dad, pickleball and chess fanatic, Mike is always chasing the next adventure—and inspiring everyday athletes to chase theirs.'
        }
      ]
    },
    gallery: [
      {
        id: 1,
        image: '/images/bureau-of-adventure/MarkWardian/bio-image-1.png',
        alt: 'Mike Wardian standing on a mountain summit next to a Katahdin sign, holding trekking poles and flashing a peace sign after a trail run.'
      },
      {
        id: 2,
        image: '/images/bureau-of-adventure/MarkWardian/bio-image-2.png',
        alt: 'Mike Wardian running across a wooden bridge during a race, focused and mid-stride with lush green trees in the background.'
      },
      {
        id: 3,
        image: '/images/bureau-of-adventure/MarkWardian/bio-image-3.png',
        alt: 'Mike Wardian celebrating at the finish line with raised fists, wearing a black Teva cap and race bib number 251.'
      },
      {
        id: 4,
        image: '/images/bureau-of-adventure/MarkWardian/bio-image-4.png',
        alt: 'Mike Wardian at the start line among other runners, wearing a white tank top with his name and bib number 1426.'
      }
    ],
    products: [
      {
        id: 1,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-1-46f5f0.png'
      },
      {
        id: 2,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-2.png'
      },
      {
        id: 3,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-3.png'
      },
      {
        id: 4,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-4.png'
      }
    ]
  },
  'evy-leibfarth': {
    name: 'Evy Leibfarth',
    slug: 'evy-leibfarth',
    hero: {
      image: '/images/bureau-of-adventure/EvyLeibfarth/hero.png',
      alt: 'Evy Leibfarth kayaking off a large waterfall surrounded by rocky cliffs and greenery.'
    },
    profile: {
      image: '/images/bureau-of-adventure/EvyLeibfarth/profile.png',
      alt: 'Evy Leibfarth standing beside her kayak, smiling at the camera while wearing a Red Bull helmet and teal paddling gear.'
    },
    socialLinks: { instagram: 'https://www.instagram.com/evykayak' },
    bio: {
      title: 'Meet Evy Leibfarth',
      paragraphs: [
        {
          id: 1,
          text: `Olympic kayaker Evy Leibfarth has been chasing whitewater adventures—and world titles—since she was 12. Now based in Charlotte, NC, she competes in slalom, kayak, and kayak cross, blending adrenaline with precision.  Off the river, she’s an EMT, public health student, and passionate about making the outdoors more inclusive and fun for all.`
        }
      ]
    },
    gallery: [
      {
        id: 1,
        image: '/images/bureau-of-adventure/EvyLeibfarth/bio-image-1.png',
        alt: 'Evy Leibfarth kayaking down a tall waterfall surrounded by lush green forest.'
      },
      {
        id: 2,
        image: '/images/bureau-of-adventure/EvyLeibfarth/bio-image-2.png',
        alt: 'Evy Leibfarth navigating through whitewater rapids, leaning into a turn with her paddle during a slalom course.'
      },
      {
        id: 3,
        image: '/images/bureau-of-adventure/EvyLeibfarth/bio-image-3.png',
        alt: 'Evy Leibfarth carrying her bright green kayak on her shoulder, wearing her paddling gear and helmet.'
      },
      {
        id: 4,
        image: '/images/bureau-of-adventure/EvyLeibfarth/bio-image-4.png',
        alt: 'Evy Leibfarth standing in shallow water holding a paddle and a black kayak, wearing a Red Bull helmet and casual outfit.'
      }
    ],
    products: [
      {
        id: 1,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-1-46f5f0.png'
      },
      {
        id: 2,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-2.png'
      },
      {
        id: 3,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-3.png'
      },
      {
        id: 4,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-4.png'
      }
    ]
  },
  'erin-ton': {
    name: 'Erin Ton',
    slug: 'erin-ton',
    hero: {
      image: '/images/bureau-of-adventure/ErinTon/hero.png',
      alt: 'Erin Ton descending rocky terrain with dramatic snowy peaks rising behind her.'
    },
    profile: {
      image: '/images/bureau-of-adventure/ErinTon/profile.png',
      alt: 'Erin Ton smiling outdoors wearing a cap and black jacket with braided hair.'
    },
    socialLinks: { instagram: 'https://www.instagram.com/erin_ton7' },
    bio: {
      title: 'Meet Erin Ton',
      paragraphs: [
        {
          id: 1,
          text: `Colorado-born mountain endurance athlete Erin Ton spends most of her time trail running and scrambling alpine ridgelines across the West. She’s set well over 100 FKTs on peaks from Colorado 14ers, to the Grand Canyon, and the Himalayas. She has also climbed 24 14ers in high heels. Erin is driven by a curiosity to test her limits and a deep love for wild landscapes.`
        }
      ]
    },
    gallery: [
      {
        id: 1,
        image: '/images/bureau-of-adventure/ErinTon/bio-image-1.png',
        alt: 'Erin Ton standing on a rocky mountain in front of a glacier, wearing a red life vest and hiking gear.'
      },
      {
        id: 2,
        image: '/images/bureau-of-adventure/ErinTon/bio-image-2.png',
        alt: 'Erin Ton crossing a zip line over a river with mountains and clouds in the background.'
      },
      {
        id: 3,
        image: '/images/bureau-of-adventure/ErinTon/bio-image-3.png',
        alt: 'Erin Ton climbing a steep, snow-covered ridge in icy mountain conditions.'
      },
      {
        id: 4,
        image: '/images/bureau-of-adventure/ErinTon/bio-image-4.png',
        alt: 'Erin Ton leaping over a stream while trail running in a mountain valley surrounded by greenery.'
      }
    ],
    products: [
      {
        id: 1,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-1-46f5f0.png'
      },
      {
        id: 2,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-2.png'
      },
      {
        id: 3,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-3.png'
      },
      {
        id: 4,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-4.png'
      }
    ]
  },
  'dane-jackson': {
    name: 'Dane Jackson',
    slug: 'dane-jackson',
    hero: {
      image: '/images/bureau-of-adventure/DaneJackson/hero.png',
      alt: 'Dane Jackson and fellow kayakers standing on a grassy hill overlooking a powerful river gorge with their kayaks laid out nearby.'
    },
    profile: {
      image: '/images/bureau-of-adventure/DaneJackson/profile.png',
      alt: 'Dane Jackson smiling and making a hand gesture while sitting in his kayak on the river, wearing a Red Bull helmet and paddling gear.'
    },
    socialLinks: {
      instagram: 'https://www.instagram.com/danejacksonkayak',
      youtube: 'https://www.youtube.com/@danejacksonkayak'
    },
    bio: {
      title: 'Meet Dane Jackson',
      paragraphs: [
        {
          id: 1,
          text: `Dane Jackson has spent his life on the water in search of the best whitewater and waterfalls this planet has to offer, all in his signature pink kayak. A five-time Freestyle World Champion, first descents everywhere from Madagascar to Pakistan, seven 100+ft waterfall descents, he strives to push himself in every discipline of whitewater kayaking.`
        },
        {
          id: 2,
          text: `Being on the water allows him to see everything from the biggest rivers, to the narrowest remote gorges, and all while trying to capture the best content possible along the way. Traveling year round, living full time in an RV, he is always searching for that next best piece of whitewater.`
        }
      ]
    },
    gallery: [
      {
        id: 1,
        image: '/images/bureau-of-adventure/DaneJackson/bio-image-1.png',
        alt: 'Dane Jackson kayaking through a wide, muddy river with powerful rapids surrounded by green hills under a blue sky.'
      },
      {
        id: 2,
        image: '/images/bureau-of-adventure/DaneJackson/bio-image-2.png',
        alt: 'Dane Jackson securing his pink kayak onto the roof of a vehicle before heading to the river.'
      },
      {
        id: 3,
        image: '/images/bureau-of-adventure/DaneJackson/bio-image-3.png',
        alt: 'Dane Jackson sitting on rocks beside a river, wearing a hoodie and sandals while relaxing in the sun.'
      },
      {
        id: 4,
        image: '/images/bureau-of-adventure/DaneJackson/bio-image-4.png',
        alt: 'Dane Jackson navigating a steep rapid in his pink kayak between large boulders, followed by other kayakers.'
      }
    ],
    products: [
      {
        id: 1,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-1-46f5f0.png'
      },
      {
        id: 2,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-2.png'
      },
      {
        id: 3,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-3.png'
      },
      {
        id: 4,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-4.png'
      }
    ]
  },
  'brigette-takeuchi': {
    name: 'Brigette Takeuchi',
    slug: 'brigette-takeuchi',
    hero: {
      image: '/images/bureau-of-adventure/BrigetteTakeuchi/hero.png',
      alt: 'Brigette Takeuchi standing on a rocky mountain peak overlooking a vast valley surrounded by tall mountains and golden terrain.'
    },
    profile: {
      image: '/images/bureau-of-adventure/BrigetteTakeuchi/profile.png',
      alt: 'Brigette Takeuchi wearing a headlamp and red jacket, standing outdoors in the mountains at dusk, adjusting her backpack straps.'
    },
    socialLinks: { instagram: 'https://www.instagram.com/brigettetakeuchi/' },
    bio: {
      title: 'Meet Brigette Takeuchi',
      paragraphs: [
        {
          id: 1,
          text: `Brigette Takeuchi is an all-around mountain athlete who thrives on movement—running trails, skiing fresh lines, and capturing it all behind the lens. Whether chasing FKT’s or traversing remote alpine ridges, she brings grit, heart, and a creative perspective to every outdoor adventure.`
        },
        {
          id: 2,
          text: `A passionate advocate for representation in the outdoors, Brigette’s always chasing summits—and helping others find their own. `
        }
      ]
    },
    gallery: [
      {
        id: 1,
        image: '/images/bureau-of-adventure/BrigetteTakeuchi/bio-image-1.png',
        alt: 'Brigette Takeuchi running uphill on a rocky mountain trail with determination, wearing a green hydration vest and black athletic outfit.'
      },
      {
        id: 2,
        image: '/images/bureau-of-adventure/BrigetteTakeuchi/bio-image-2.png',
        alt: 'Brigette Takeuchi and two other hikers walking on a rocky mountain trail beside a glacier under bright sunlight.'
      },
      {
        id: 3,
        image: '/images/bureau-of-adventure/BrigetteTakeuchi/bio-image-3.png',
        alt: 'Three women, including Brigette Takeuchi, trail running along a rocky mountain ridge at sunrise with misty peaks in the background.'
      },
      {
        id: 4,
        image: '/images/bureau-of-adventure/BrigetteTakeuchi/bio-image-4.png',
        alt: 'Brigette Takeuchi sitting beside a small red mountain hut near a glacier, relaxing in the sun after a long hike.'
      }
    ],
    products: [
      {
        id: 1,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-1-46f5f0.png'
      },
      {
        id: 2,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-2.png'
      },
      {
        id: 3,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-3.png'
      },
      {
        id: 4,
        name: "Men's Trailwinder Low",
        image: '/images/bureau-of-adventure/AlvinDedeaux/product-4.png'
      }
    ]
  }
};

/**
 * Returns the content of an athlete by the slug.
 * @param athleteSlug - The slug of the athlete.
 * @returns The content of the athlete.
 */
export const getAthleteContent = (
  athleteSlug: AthleteSlug
): IAthleteContent | null => {
  return athletesData[athleteSlug] ?? null;
};
